// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".browser[data-v-1bed5b8c]{height:100vh}.safari[data-v-1bed5b8c]{height:calc(100vh - 75px)}.pb-safe[data-v-1bed5b8c]{padding-bottom:env(safe-area-inset-bottom,16px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
